module.exports = __webpack_public_path__ + "static/media/icon-checked.29fca2d2.svg";